import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api/index';
import {
  CalculatePostMaloneScoreMutation,
  CalculatePostMaloneScoreMutationVariables
} from './__generated__/CalculatePostMaloneScoreMutation';
import { CALCULATE_POST_MALONE_SCORE_MUTATION } from './calculatePostMaloneScore.mutation';

type MutationProps = {
  onStart?: () => void;
  onCompleted?: (engagementScore: number) => void;
  onError?: (errors: string[]) => void;
};

export const useCalculatePostMaloneScoreMutation = ({
  onCompleted,
  onError
}: MutationProps): [(variables: CalculatePostMaloneScoreMutationVariables) => void, { loading: boolean }] => {
  const [mutationFunc, { loading }] = useMutation<
    CalculatePostMaloneScoreMutation,
    CalculatePostMaloneScoreMutationVariables
  >(CALCULATE_POST_MALONE_SCORE_MUTATION, {
    client: kmsClient,
    onCompleted: (data) => {
      if (data.calculatePostMaloneScore?.errors?.length) {
        if (onError) onError(data.calculatePostMaloneScore.errors);
      } else if (data.calculatePostMaloneScore && data.calculatePostMaloneScore?.engagementScore !== null) {
        if (onCompleted) onCompleted(data.calculatePostMaloneScore.engagementScore);
      } else {
        if (onError) onError(['Something went wrong']);
      }
    },
    onError: (error) => {
      if (error.message.includes('The user aborted a request')) return;

      onError && onError([error.message]);
    }
  });
  return [
    (variables) => {
      mutationFunc({ variables });
    },
    { loading }
  ];
};
